import { Button, TypographySubtle } from '@seen/ui'
import { IconX } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'
import { Card } from '#src/components/core/Card.tsx'

export interface BulkActionBarProps {
  count: number
  onClear: () => void
  children?: ReactNode
}

export function BulkActionBar({
  count,
  onClear,
  children,
}: BulkActionBarProps): JSX.Element | null {
  if (count <= 0) {
    return null
  }

  return (
    <Card className="fixed bottom-3 left-[50%] z-10 flex h-fit w-fit -translate-x-1/2 items-center gap-2 p-2 shadow-lg">
      <div className="flex items-center">
        <div className="flex items-center self-stretch rounded-md rounded-r-none border border-r-0 border-dashed px-4">
          <TypographySubtle>{count} selected</TypographySubtle>
        </div>
        <Button
          variant="outline"
          className="rounded-l-none border-dashed shadow-none"
          size="icon"
          aria-label="Clear selection"
          onClick={onClear}
        >
          <IconX className="size-4" />
        </Button>
      </div>
      <div className="h-8 border-l" />
      {children}
    </Card>
  )
}
